import { useState } from "react";
import { FadeUp } from "./Reveal";

const Maker = () => {
    const [fotoMist, setFotoMist] = useState(false);

    return (
    <section data-testid="maker-section" className="bg-[#F9FAFB] py-24 md:py-32">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
            <FadeUp>
                <p className="text-xs tracking-[0.3em] uppercase font-bold text-[#FF6B00] mb-8">De maker</p>
                <div className="grid md:grid-cols-[280px_1fr] gap-10 md:gap-16 items-start">
                    {fotoMist ? (
                        <div data-testid="maker-foto-fallback" className="aspect-[4/5] w-56 md:w-full rounded-2xl bg-[#0047FF] blue-glow flex items-center justify-center">
                            <span className="font-heading font-black text-6xl text-white tracking-tight">Ed</span>
                        </div>
                    ) : (
                        <img
                            data-testid="maker-foto"
                            src="/images/ed.jpg"
                            alt="Ed van Wijk, maker van MeerjarenplanOnline.nl"
                            onError={() => setFotoMist(true)}
                            className="aspect-[4/5] w-56 md:w-full rounded-2xl object-cover object-top shadow-xl"
                        />
                    )}
                    <div>
                        <h2 className="font-heading text-3xl sm:text-4xl font-black tracking-tight text-[#0A0A0A]">
                            Maak kennis met Ed van Wijk
                        </h2>
                        <p className="mt-6 text-[#0A0A0A]/70 leading-relaxed">
                            Als geoloog maakte ik 40 jaar geleden kennis met Monte Carlo simulaties, in de
                            vele jaren daarna ben ik veel met de ontwikkeling van modelleringssoftware bezig
                            geweest.
                        </p>
                        <p className="mt-4 text-[#0A0A0A]/70 leading-relaxed">
                            De afgelopen jaren heb ik me nuttig geprobeerd te maken bij verenigingen:
                            watersport, natuur- en landschapsbescherming, en nu havenconcerten. Daar viel
                            me op dat het niet simpel was om meerjarenbegrotingen te maken — of met
                            over-ingewikkelde Excel files, of met een dure accountant naast je. Dus
                            bouwde ik er zelf een: onafhankelijk, supersnel, betaalbaar en gemakkelijk —
                            gemaakt voor de vrijwilligers die het echte werk doen.
                        </p>
                        <p className="mt-6 font-heading font-bold text-[#0A0A0A] tracking-tight">
                            — Ed van Wijk, oprichter Club-Fin.nl
                        </p>
                    </div>
                </div>
            </FadeUp>
        </div>
    </section>
    );
};

export default Maker;
